var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('img',{attrs:{"src":require("../../../static/404.png")}}),_c('div',{staticClass:"info"},[_c('div',{staticClass:"title"},[_vm._v("访问错误！")]),_c('div',{staticClass:"content"},[_vm._v("你不能进入这个页面...")]),_c('div',{staticClass:"tip"},[_vm._v("请检查您是否有操作权限")])])])
}]

export { render, staticRenderFns }